"use client";

export { default } from "../../shared/PublicRouteError";
